import React from 'react'

/**
 * KPI card.
 *
 * `percent` / `previous` render the comparison line as before. When `change`
 * is supplied the card instead shows a direction-aware delta ("▼ 21.9%")
 * alongside the previous period's figure, coloured by whether the movement is
 * good news. The colour used to be passed in as a fixed class, so a fall in
 * interactions was reported in green.
 *
 * `higherIsBetter` flips the colouring for metrics where down is good, such as
 * the escalation rate.
 */
const Cards = ({
    category,
    number,
    percent,
    icon,
    iconColor,
    percentColor,
    previous,
    change,
    higherIsBetter = true,
}) => {
    const hasChange = typeof change === 'number' && Number.isFinite(change);
    const isFlat = hasChange && Math.round(change * 10) === 0;
    const isGood = hasChange && (change > 0 ? higherIsBetter : !higherIsBetter);

    const arrow = !hasChange || isFlat ? '' : change > 0 ? '▲' : '▼';
    const changeColor = !hasChange || isFlat
        ? 'text-gray-600'
        : isGood
            ? 'text-green'
            : 'text-red-500';

    return (
        <div className='shadow-custom rounded-3xl p-7 w-1/3 md:w-full xs:w-full'>
            <div className='flex flex-row justify-between'>
                <p className='text-base text-black font-semibold'>{category}</p>
                <div className="text-3xl">
                    <span className={`${iconColor}`}>{icon}</span>
                </div>
            </div>
            <div>
                <p className='text-black text-3xl font-bold mt-4'>{number}</p>
            </div>
            <div className='flex flex-row justify-start mt-4 gap-1 items-baseline'>
                {hasChange ? (
                    <>
                        <p className='text-sm font-semibold'>
                            <span className={changeColor}>
                                {arrow} {Math.abs(change).toFixed(1)}%
                            </span>
                        </p>
                        <p className='text-sm font-normal text-gray-600'>{previous}</p>
                    </>
                ) : (
                    <>
                        <p className='text-sm font-semibold'><span className={`${percentColor}`}>{percent}</span></p>
                        <p className='text-sm font-normal text-gray-600'> {previous}</p>
                    </>
                )}
            </div>
        </div>
    )
}

export default Cards
